import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoginDefaultWizardService } from './login-default.wizard.service';
import { AuthService } from '../../auth.service';
import { SectorFilter } from '../../../model/sector-filter';
import { Center } from '../../../model/center';
import { ServiceService } from '../../service.service';
import { MessageServerService } from '../../hub-services/message-server/message-server.service';
import { CompanyFilter } from 'src/app/model/company-filter';


export interface ILoginWizard {
  login(userName: string, userPassword: string, returnUrl: string): Promise<void>;
  setSectorCenterAndCompanies(sector: SectorFilter, center: Center, companies: CompanyFilter[]);
  getAllCenters(): Center[];
  getSectors(centerId: number): SectorFilter[];
  getAllCompanies(): CompanyFilter[];
}

@Injectable()
export class LoginWizardService {
  private loginWizard: ILoginWizard;

  constructor(http: HttpClient,
    router: Router,
     private messageServerService: MessageServerService,
     serviceService: ServiceService,
     authService: AuthService) {

    this.loginWizard = new LoginDefaultWizardService( router, serviceService,
      this.messageServerService, authService);
  }

  async login(userName: string, userPassword: string, returnUrl: string): Promise<void> {
    await this.loginWizard.login(userName, userPassword, returnUrl);
  }

  getAllCompanies(): CompanyFilter[] {
    return this.loginWizard.getAllCompanies();
  }

  getAllCenters(): Center[] {
    return this.loginWizard.getAllCenters();
  }

  getSectors(centerId: number): SectorFilter[] {
    return this.loginWizard.getSectors(centerId);
  }

  setSectorCenterAndCompanies(sector: SectorFilter, center: Center, companies: CompanyFilter[]): void {
    return this.loginWizard.setSectorCenterAndCompanies(sector, center, companies);
  }
}


